export const LANGUAGE_SEGMENT_MAX_DEPTH = 3;
export const CONTENT_PREVIEW_MODE = 'preview';
export const GOOGLE_MAPS_URL = 'https://maps.google.com/maps';
export const SITE_WITH_ROOT_NAME_LANGUAGE_SEGMENT_INDEX = 0;
